module.exports = __webpack_public_path__ + "media/images/emblems/Savosa-coat_of_arms-692c9d71a50b8adf2a976825778c9175.svg";